export const locale = {
    lang: 'pl',
    data: {
        'Customers': 'Klienci',
        'New': 'Nowy',
        'Edit': 'Edycja',
        'Card number': 'Numer karty',
        'Username': 'Użytkownik',
        'Phone': 'Telefon',
        'First name': 'Imię',
        'Last name': 'Nazwisko',
        'Actions': 'Akcje',
        'Customer data': 'Dane klienta',
        'First Name is required!': 'Imię jest wymagane!',
        'Last Name is required!': 'Nazwisko jest wymagane!',
        'User name is required!': 'Nazwa użytkownika jest wymagana!',
        'E-mail is required!': 'E-mail jest wymagany!',
        'Street': 'Ulica',
        'House number': 'Nr domu',
        'Flat number': 'Nr mieszkania',
        'Post code': 'Kod pocztowy',
        'City': 'Miasto',
        'Country': 'Kraj',
        'Sex': 'Płeć',
        'Female': 'Kobieta',
        'Male': 'Mężczyzna',
        'Birth day': 'Dzień urodzenia',
        'Birth month': 'Miesiąc urodzenia',
        'Birth year': 'Rok urodzenia',
        'Name day': 'Dzień imienin',
        'Name month': 'Miesiąc imienin',
        'Customer source': 'Źródło pochodzenia',
        'Save': 'Zapisz',
        'Scheduled for today': 'Umówieni na dzisiaj',
        'Created in last time': "Ostatnio dodani",
        'Personal data': 'Dane dodatkowe',
        'Summary': 'Podsumowanie',
        'Birthday': 'Data urodzenia',
        'Created at': 'Data dodania',
        'Cards': 'Karty',
        'Add card': 'Dodaj kartę',
        'Add new card to': 'Dodaj nową kartę do',
        'Available credits': 'Dostępne kredyty',
        'HISTORY': 'HISTORIA',
        'ADD SERVICE': 'DODAJ USŁUGĘ',
        'LOCK': 'ZABLOKUJ',
        'Resources in use': 'Urządzenia w użyciu',
        'In use': 'Używa',
        'Started at': 'Rozpoczęto',
        'For all services': 'Na wszystkie usługi',
        'Service': 'Usługa',
        'Credits': 'Kredyty',
        'Expiration date': 'Data ważności',
        'Add new service to card': 'Dodaj nową usługę do karty',
        'of': 'należącej do',
        'User': 'Użytkownik',
        'ACCEPT ENTRANCE': 'AKCEPTUJ WEJŚCIE',
        'ACCEPTED': 'ZAAKCEPTOWANE',
        'Type to filter customers list...': 'Filtruj listę użytkowników...',
        'Users online': 'Użytkownicy online',
        'MINUS SERVICE': 'ODEJMIJ USŁUGĘ',
        'Minus service': 'Odejmij usługę',
        'Familiarized himself with the contraindications': 'Zapoznał się z przeciwwskazaniami',
        'Read the regulations': 'Zapoznał się z regulaminem',
        'Read the price list': 'Zapoznał się z cennikiem',
        'GDPR agrees': 'Zgody RODO',
        'Consent to marketing': 'Zgody marketingowe',
        'Delete': 'Usuń',
        'QR CODE': 'KOD QR',
        'Communication': 'Komunikacja',
        'Resources online': 'Urządzenia online',
        'Registered at': 'Data rejestracji',
        'First traditional sale': 'Pierwszy zakup w salonie',
        'First online sale': 'Pierwszy zakup online',
        'Orders': "Zamówienia",
        'CHANGE NUMBER': 'ZMIEN NUMER',
        'Cards quantity': 'Ilość kart',
        'Reservations': 'Rezerwacje',
        'Notification history': 'Historia wiadomości',
        'Date': 'Data',
        'Channel': 'Kanał',
        'Destination': 'Adres',
        'Topic': 'Tytuł',
        'Message': 'Wiadomość'
    }
};
